export const user = {
  page_heading: "Users",
  editor_label_identifier: "ID",
  empty_state_message:
    "Add users to grant access and start managing permissions for this organisation.",
  health_empty_state_message:
    "Add users to grant access and start managing permissions for this account.",

  // List Screen
  list_title_prefix: "Users informations for ",
  list_subtitle_health:
    "Manage users who have access to this account. You can create, edit, or remove users and control their permissions.",
  list_subtitle_hr:
    "Manage users who have access to this organisation. You can create, edit, or remove users and control their permissions.",

  // Add/Edit User Screen
  add_title_prefix: "Add Users informations for ",
  add_subtitle:
    "Create a new user and assign access permissions. User details and roles can be updated at any time.",
  edit_title_prefix: "Edit Users informations for ",
  edit_subtitle:
    "Add users to grant access and start managing permissions for this organisation.",
  health_edit_subtitle:
    "Add users to grant access and start managing permissions for this account.",
  basic_information: "Basic information",

  // Form labels
  identifier_label: "User's ID",
  first_name_label: "First name",
  last_name_label: "Last name",
  email_label: "Email",
  phone_number_label: "Phone number",
  location_label: "Location",

  // Placeholders
  placeholder_identifier: "Enter user ID here...",
  placeholder_first_name: "Enter first name here...",
  placeholder_last_name: "Enter last name here...",
  placeholder_email: "Enter email here...",
  placeholder_phone_number: "Enter phone number here...",
  placeholder_location: "Enter location here...",

  // Messages
  create_success: "User created successfully!",
  create_error: "Failed to create user. Please try again.",
  update_success: "User updated successfully!",
  update_error: "Failed to update user. Please try again.",
  delete_success: "User deleted successfully!",
  delete_error: "Failed to delete user. Please try again.",
  error_identifier_required: "User ID is required.",
  error_no_home: "No sub-organisation selected.",
  error_no_user: "User not found.",
};
